"use client";

import translations from "@/lib/translations.json";
import ProblemAfter from "./ProblemAfter";
import ProblemBefore from "./ProblemBefore";
import { useWebsiteLang } from "../context/website-lang-context";

export default function Problem() {
  const { lang } = useWebsiteLang();
  const t = translations[lang].website.problem;

  return (
    <section className="relative overflow-hidden py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-amber-500/20 px-4 py-1.5 text-xs font-medium text-amber-400 glass">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse-slow" />
            {t.badge}
          </div>
          <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            {t.titlePrefix}{" "}
            <span className="text-gradient-amber">{t.titleHighlight}</span>
          </h2>
          <p className="mx-auto max-w-2xl text-base md:text-lg text-white/50">
            {t.subtitle}
          </p>
        </div>

        <div className="grid gap-4 lg:grid-cols-2 lg:gap-6">
          <div
            className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5"
            style={{ minHeight: "360px" }}
          >
            <ProblemBefore />
          </div>

          <div
            className="relative overflow-hidden rounded-2xl border border-amber-500/20 bg-white/5 glow-amber"
            style={{ minHeight: "360px" }}
          >
            <ProblemAfter />
          </div>
        </div>
      </div>
    </section>
  );
}
